import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const CountdownWrapper = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 40px;
    padding: 24px 16px;
    background-color: ${theme.colors.white};
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);

    ${breakpoint('lg')`
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 32px 40px;
    `}
  `}
`;

export const CountdownIntro = styled.div`
  min-width: 0;
`;

export const CountdownBooks = styled.p`
  ${({ theme }) => css`
    margin: 16px 0 0;
    color: ${theme.colors.gray['600']};
    font-size: ${theme.font.size.pixel('16')};
    font-weight: ${theme.font.weight.bold};
    line-height: 1.4;
  `}
`;

export const CountdownSubtitle = styled.p`
  ${({ theme }) => css`
    margin: 16px 0 0;
    color: ${theme.colors.gray['600']};
    font-size: ${theme.font.size.pixel('16')};
    line-height: 1.5;

    ${CountdownBooks} + & {
      margin-top: 4px;
    }
  `}
`;

export const CountdownUnits = styled.div`
  display: flex;
  gap: 8px;

  ${breakpoint('sm')`
    gap: 12px;
  `}
`;

export const CountdownUnit = styled.div`
  ${({ theme }) => css`
    flex: 1 1 0;
    min-width: 0;
    padding: 12px 4px 10px;
    text-align: center;
    background-color: ${theme.colors.tertiary};
    border-bottom: 4px solid ${theme.colors.primary};

    ${breakpoint('md')`
      flex: 0 0 auto;
      width: 104px;
      padding: 18px 8px 14px;
    `}
  `}
`;

export const CountdownValue = styled.span`
  ${({ theme }) => css`
    display: block;
    color: ${theme.colors.white};
    font-size: ${theme.font.size.pixel('28')};
    font-weight: ${theme.font.weight.bold};
    font-variant-numeric: tabular-nums;
    line-height: 1;

    ${breakpoint('md')`
      font-size: ${theme.font.size.pixel('42')};
    `}
  `}
`;

export const CountdownLabel = styled.span`
  ${({ theme }) => css`
    display: block;
    margin-top: 8px;
    color: ${theme.colors.gray['300']};
    font-size: ${theme.font.size.pixel('10')};
    letter-spacing: 0.08em;
    text-transform: uppercase;

    ${breakpoint('md')`
      font-size: ${theme.font.size.pixel('12')};
    `}
  `}
`;
